import { Component, OnInit } from '@angular/core';
import { AuthStorage } from '@tix/auth/services';

@Component({
  selector: 'tix-frontoffice-wrapper',
  templateUrl: './frontoffice-wrapper.component.html'
})
export class FrontofficeWrapperComponent implements OnInit {
  ngOnInit(): void {
    AuthStorage.setItem('role', 'customer');
    AuthStorage.setItem('isOnFrontoffice', true);
  }
}
